export interface LanguageItemData {
  readonly id: string;
  readonly segments: Record<string, string>;
}

export const defaultSegmentName = '__default__';

export interface LanguageResourceData {
  name: string;
  language: string;
  items: LanguageItemData[];
}
